module.exports = __webpack_public_path__ + "media/Generic Tap 4c.309aa449.mp3";